import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/legal.css";

const AccessibilityPage = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Header />
      <main className="legal-page">
        <h1>Accessibility Statement</h1>
        <p className="legal-meta">
          Continental Lease Advisors LLC &nbsp;|&nbsp; Statement date: July 28, 2026
        </p>

        <p>
          Continental Lease Advisors LLC ("CLA") is committed to making this
          website accessible to all users, including people with disabilities.
          We are working to conform to the{" "}
          <strong>
            Web Content Accessibility Guidelines (WCAG) 2.2 Level AA
          </strong>
          .
        </p>

        <h2>What We Have Done</h2>
        <ul>
          <li>
            <strong>Skip navigation:</strong> A "Skip to main content" link
            appears at the top of every page for keyboard users.
          </li>
          <li>
            <strong>Semantic HTML:</strong> The site uses HTML5 landmark
            elements (header, nav, main, footer) to support screen reader
            navigation.
          </li>
          <li>
            <strong>Text alternatives:</strong> Images include descriptive{" "}
            <code>alt</code> attributes. Decorative images have empty alt text
            so screen readers skip them.
          </li>
          <li>
            <strong>Form labels:</strong> All form fields are associated with
            visible or screen-reader-only labels via the{" "}
            <code>htmlFor</code> / <code>aria-label</code> pattern.
          </li>
          <li>
            <strong>Keyboard navigation:</strong> All interactive elements
            (links, buttons, form fields) are reachable and operable via
            keyboard alone, with visible focus indicators.
          </li>
          <li>
            <strong>Color contrast:</strong> Text colors meet the minimum 4.5:1
            contrast ratio against their backgrounds for normal text, per WCAG
            2.2 success criterion 1.4.3.
          </li>
          <li>
            <strong>ARIA attributes:</strong> Interactive controls that lack
            visible text labels include <code>aria-label</code> attributes.
          </li>
          <li>
            <strong>Global Privacy Control:</strong> This site detects and
            honors the GPC signal to respect browser-level opt-out preferences.
          </li>
        </ul>

        <h2>Known Limitations</h2>
        <p>
          We are continuously reviewing and improving this site. Known areas
          still under review include:
        </p>
        <ul>
          <li>
            Some decorative images in older sections use generic alt text
            ("banner") rather than fully descriptive text. We are revising these.
          </li>
          <li>
            PDF documents or third-party embeds, if added in the future, may not
            fully conform until reviewed separately.
          </li>
        </ul>

        <h2>How to Get Help or Report an Issue</h2>
        <p>
          If you experience a barrier while using this site, or if any content
          is inaccessible to you, please contact us:
        </p>
        <ul>
          <li>
            <strong>Email:</strong>{" "}
            <a href="mailto:[CONTACT EMAIL]">[CONTACT EMAIL]</a>
          </li>
        </ul>
        <p>
          Please describe the page URL, the issue you encountered, and the
          assistive technology you are using. We aim to respond within{" "}
          <strong>5 business days</strong>.
        </p>

        <h2>Formal Complaints</h2>
        <p>
          If you are unsatisfied with our response, you may contact the{" "}
          <strong>U.S. Department of Justice Civil Rights Division</strong> at{" "}
          <a
            href="https://www.ada.gov"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.ada.gov
          </a>
          .
        </p>

        <div className="legal-placeholders">
          <p>Placeholders to fill in before publishing:</p>
          <ul>
            <li>[CONTACT EMAIL] — accessibility contact email address</li>
          </ul>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AccessibilityPage;